import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  MAINTENANCE_FINANCIALS_REPORT_GET_ORGANIZATION_LIST: createSagaAction(
    'MAINTENANCE_FINANCIALS_REPORT_GET_ORGANIZATION_LIST'
  ),
  MAINTENANCE_FINANCIALS_REPORT_GET_FULL_REPORT: createSagaAction(
    'MAINTENANCE_FINANCIALS_REPORT_GET_FULL_REPORT'
  )
}

// Action Creators
export const actions = {
  maintenanceFinancialsReportGetOrganizationList: ({ filters }) => ({
    type: constants.MAINTENANCE_FINANCIALS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    filters
  }),
  maintenanceFinancialsReportGetFullReport: ({ filters }) => ({
    type: constants.MAINTENANCE_FINANCIALS_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.MAINTENANCE_FINANCIALS_REPORT_GET_ORGANIZATION_LIST.ACTION:
      return { ...state, error: null, loadingOrganizationList: true }
    case constants.MAINTENANCE_FINANCIALS_REPORT_GET_ORGANIZATION_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingOrganizationList: false,
        organizationList: action.payload
      }

    case constants.MAINTENANCE_FINANCIALS_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.MAINTENANCE_FINANCIALS_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/financial/maintenanceFinancialsReportActions.js